const setDashboard = (state, action) => action.dashboard || state;
export default setDashboard;
